<template>
	<el-dialog
		:title="'练习完成'"
		:visible.sync="visibleProxy"
		width="460px"
		:close-on-click-modal="false"
		:close-on-press-escape="false"
	>
		<div class="tsd-header">
			<p class="tsd-level">得分：<span class="tsd-score">{{ computedScore }}</span> 分</p>
			<p class="tsd-pass" :class="{ 'is-pass': computedPassed }">{{ computedPassed ? '通过，干得漂亮！' : '未通过，继续加油哦！' }}</p>
		</div>
		<div class="tsd-table">
			<table cellspacing="0" cellpadding="0">
				<thead>
					<tr>
						<th colspan="2">操作项目</th>
						<th class="col-score">得分</th>
					</tr>
				</thead>
				<tbody>
					<tr v-for="(row, idx) in computedItems" :key="idx">
						<template v-if="row.isSection">
							<td class="is-advance" colspan="2">{{ row.label }}</td>
							<td class="col-score"></td>
						</template>
						<template v-else>
							<td>{{ row.label }}</td>
							<td class="col-value">{{ row.value }}</td>
							<td class="col-score">{{ formatScore(row.score) }}</td>
						</template>
					</tr>
					<template v-if="actionTypeMap && actionTypeMap.length > 0">
						<tr v-for="(actionType, index) in actionTypeMap" :key="actionType.actionType">
							<td v-if="index === 0" style="color: red" :rowspan="actionTypeMap.length">高级操作</td>
							<td class="col-value">漏掉{{ actionType.actionType == 'TRANSFER_AFTER_SALE' ? '转接售后' : (actionType.actionType == 'REMARK_MODIFY' ? '添加备注' : '')}}{{ actionType.times }}次</td>
							<td class="col-score">-{{ actionType.points }}</td>
						</tr>
					</template>
				</tbody>
				<tfoot>
					<tr>
						<td class="total" colspan="2">总分</td>
						<td class="col-score">{{ computedScore }}</td>
					</tr>
				</tfoot>
			</table>
		</div>
		<span slot="footer" class="dialog-footer">
			<el-button @click="onRestart" plain>再练一次</el-button>
			<el-button type="primary" @click="onViewResult">查看结果</el-button>
		</span>
	</el-dialog>
</template>

<script>
export default {
	name: 'TrainScoreDialog',
	props: {
		visible: { type: Boolean, default: false },
		// 后端返回的完整结果对象
		result: { type: Object, default: function () { return null; } }
	},
	data() {
		return {
        };
	},
	computed: {
        visibleProxy: {
			get() { return this.visible; },
			set(v) { this.$emit('update:visible', v); }
		},
		actionTypeMap() {
			let actionTypeMap = this.result && this.result.actionTypeMap || null;
			return actionTypeMap;
		},
		computedItems() {
			var t = (this.result && this.result.train) || {};
			var s = (this.result && this.result.score) || {};
			return [
				{ label: '平均首次响应时间', value: (t.restime != null ? t.restime : 0) + '秒', score: s.firstResponseAvgScore || 0 },
				{ label: '平均响应时间', value: (t.avgrestime != null ? t.avgrestime : 0) + '秒', score: s.responseAvgScore || 0 },
				{ label: '回复率', value: (t.responseRate != null ? t.responseRate : 0) + '%', score: s.responseRateScore || 0 },
				{ label: '回复正确率', value: (t.responseRightRate != null ? t.responseRightRate : 0) + '%', score: s.responseRightScore || 0 }
			];
		},
		computedScore() {
			return (this.result && this.result.train && (this.result.train.sysScore || 0)) || 0;
		},
		computedPassed() {
			return !!(this.result && this.result.train && Number(this.result.train.pass) === 1);
		}
	},
	methods: {
		formatScore(score) { return (Number(score) || 0); },
		onRestart() { this.$emit('onRestart'); },
		onViewResult() { this.$emit('onViewResult'); },
	}
};
</script>

<style lang="less" scoped>
.tsd-header {
	text-align: center;
	.tsd-level {
		font-size: 25px;
		margin: 0 0 6px 0;
		.tsd-score { color: #f56c6c; font-weight: 600; }
	}
	.tsd-pass {
		margin: 0 0 12px 0;
		color: #333;
        font-size: 20px;
		&.is-pass { color: #67C23A; }
	}
}

.tsd-table {
	background: #fff;
	border: 1px solid #dfe6ec;
	border-radius: 2px;
	overflow: hidden;
	margin-bottom: 8px;
	 table {
		width: 100%;
		border-collapse: collapse;
		th, td { border: 1px solid #dfe6ec; padding: 8px 10px; font-size: 12px; }
		thead th { background: #2F78FF; color: #fff; font-weight: 600; }
		.col-score { width: 80px; text-align: center; }
		.is-advance { color: #f56c6c; }
		.is-negative { color: #f56c6c; }
		.total { text-align: center; font-weight: 600; color: #f56c6c; }
	 }
}

.dialog-footer {
	text-align: center;
}
</style>





// WEBPACK FOOTER //
// ./src/page/train/FBT/components/TrainScoreDialog.vue